import { render, staticRenderFns } from "./UtilisateurDirecteur.vue?vue&type=template&id=28b42f5a&scoped=true&"
import script from "./UtilisateurDirecteur.vue?vue&type=script&lang=js&"
export * from "./UtilisateurDirecteur.vue?vue&type=script&lang=js&"
import style0 from "./UtilisateurDirecteur.vue?vue&type=style&index=0&id=28b42f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b42f5a",
  null
  
)

export default component.exports